export enum SkillLevel {
  Insuffisant,
  Correct,
  Bien,
  Excellent,
}
